import _ from 'lodash'
import React from 'react'
import styled from 'styled-components'
import * as ScrollViewControl from '../lib/scrollViewControl'

const rgba = (r, g, b, a) => `rgba(${r}, ${g}, ${b}, ${a})`
const setButtonColor = props => {
  const opacity = !props.disabled ? 1 : 0.5
  return !!props.secondary
    ? rgba(255, 255, 255, opacity)
    : rgba(0, 0, 0, opacity)
}

export const Text = styled.span`
  display: ${props => !!props.block ? 'block' : 'inline'};
  margin-bottom: ${props => !!props.block ? '10px' : 'auto' };
  text-align: ${props => !!props.center ? 'center' : ''};
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  font-size: ${props => !!props.small ? '10px' : !!props.xsmall ? '9px' : '10px'};
  line-height: 1.6em;
  @media only screen and (min-width: 768px) {
    font-size: ${props => !!props.small ? '10px' : !!props.xsmall ? '9px' : '14px'};
    line-height: 1.2em;
  }
  html[lang=tw] & {
    font-size: ${props => !!props.small ? '12px' : !!props.xsmall ? '12px' : '12px'};
    @media only screen and (min-width: 768px) {
      font-size: ${props => !!props.small ? '12px' : !!props.xsmall ? '12px' : '16px'};
    }
  }
`

export const ModalText = Text.extend`
  color: #000000;
  line-height: 1.3em;
  letter-spacing: -0.03em;
`

export const Button = styled.button`
  font-family: 'ABChanel PB Regular S', Arial, sans-serif;
  display: inline-block;
  background-color: ${props => !!props.secondary ? 'black' : 'white'};
  color: ${props => setButtonColor(props)};
  border: 1px solid white;
  width: 100%;
  width: calc(100% - 0.5rem);
  padding: 14px 20px;
  font-size: 12px;
  line-height: 1em;
  appearance: none;
  box-shadow: none;
  position: relative;
  html[lang=tw] & {
    font-size: 14px;
  }
  .icon-loader {
    position: absolute;
    top: 10px;
    right: 30px;
  }
  @media only screen and (min-width: 768px) {
    padding-left: 28px;
    padding-right: 28px;
    min-width: 232px;
    width: ${props => !!props.primary || !!props.secondary ? '320px' : 'auto'};
  }
`

export const ModalButton = Button.extend`
  background-color: ${props => !!props.secondary ? 'white' : 'black'};
  color: ${props => !!props.secondary ? 'black' : 'white'};
  min-width: 204px;
  border: solid 1px #d7d7d7;
  /* margin-top: 9px;
  margin-bottom: 9px; */
  margin: 5px 0.25rem;
`

export const ModalTitle = styled.div`
  font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
  font-size: 13px;
  font-weight: normal;
  letter-spacing: -0.3px;
  text-align: center;
  color: #000000;
  html[lang=tw] & {
    font-size: 16px;
  }
`

export const StyledModal = styled.div`
  font-family: HelveticaNeue, Helvetica, Arial;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: block;
  transform: translate3d(0,0,0);

  .modal-backdrop-clickarea {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(255, 0, 0, 0.5); */
    z-index: 0;
  }
  .modal-backdrop {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 998;
    background: rgba(0, 0, 0, 0.5);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-top: 50px;
    padding-bottom: 100px;
  }
  .modal-container {
    position: relative;
    margin: auto;
    padding: 4.75vw 3vw 3.5vw;
    width: 78.67vw;
    max-width: ${props => !!props.small ? '500px':'900px'};
    background: white;
    color: black;
    border: 3px solid black;
    @media only screen and (min-width: 768px) {
      padding: 40px 50px 30px;
    }
    a {
      color: black;
    }
    ul {
      margin-left: 0;
      padding-left: 1.5em;
    }
  }
  .modal-body {
    padding: 13px 15px;
  }
  .modal-footer {
    display: block;
    border: none;
    text-align: center;
    padding: 6px 5px;
    margin-top: 8px;
  }
`
class Modal extends React.Component {
  state = {
    show: false,
    cancelable: true
  }
  _lastScrollPosition = null
  open = () => {
    this._lastScrollPosition = window.pageYOffset
    this.setState(()=>{
      ScrollViewControl.preventScrolling()
      document.documentElement.style.top = `-${this._lastScrollPosition}px`
      return { show: true }
    })
  }
  close = () => {
    this.setState(() => {
      ScrollViewControl.allowScrolling()
      window.scrollTo(0, this._lastScrollPosition)
      return { show: false, title: null, small: false, buttons: [], cancelable: true }
    })
  }
  render() {
    const { children, body, className = '', small, title = null, buttons = [], cancelable = true, ...others } = this.props
    return this.state.show &&
      <StyledModal small={small}>
        <div className="modal-backdrop">
          <div className="modal-backdrop-clickarea" onClick={cancelable ? this.close : null}></div>
          <div className={`modal-container ${className}`} {...others}>
            {!_.isEmpty(title) && <ModalTitle>{title}</ModalTitle>}
            <div className={`modal-body`}>{body ? <ModalText block center>{body}</ModalText> : children}</div>
            {!_.isEmpty(buttons) && <div className={`modal-footer`}>
              {buttons.map((button, index) => {
                if (React.isValidElement(button)) {
                  return button
                } else {
                  const { className, onClick, text, ...buttonOthers} = button
                  return <ModalButton key={`modal-button-${index}`} primary className={className} onClick={onClick} {...buttonOthers}>{text}</ModalButton>
                }
              })}
            </div> }
          </div>
        </div>
      </StyledModal>
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js